import { Component, Input, NgModule } from '@angular/core';
//import * as moment from 'moment';
import moment from 'moment';

@Component({
    selector: 'app-birthday-timeline',
    templateUrl: './birthday-timeline.component.html',
    styleUrls: ['./birthday-timeline.component.scss'],
    standalone: false
})
export class BirthdayTimelineComponent {

  @Input() dateOfBirthImageUrl: string;
  @Input() dateOfBirthHeader: string;
  @Input() dateOfBirthDescription: string;
  @Input() dateOfBirthInputLabel: string;
  @Input() dateOfBirthInputButton: string;
  @Input() threeMonthsAfterContent: string;
  @Input() threeMonthsBeforeContent: string;
  @Input() signUpContentLeft: string;
  @Input() signUpContentRight: string;
  @Input() switchingSixtyFive: any;
  @Input() startExploring: string;
  @Input() openEnrollmentStarts: string;
  @Input() enrollmentPeriodEnds: string;
  @Input() birthdayLabel: string;
  @Input() addMonths: string;

  selectedDOB: string;
  selectDOB: string;
  threeMonthsBeforeDate: Number;
  threeMonthsAfterDate: Number;
  dateOfBirth: Number;
  birthdayDate: any;
  isVisibile: boolean = false;
  isMonthVisibile: any;
  contentVisibility: any = false;
  textHeight: number;
  isDateInvalid:boolean;

  constructor() {
  }
ngOnInit(){

  if(this.switchingSixtyFive === 'true'){
     this.contentVisibility = true;
  }
  this.isMonthVisibile = parseInt(this.addMonths);

}
  validateDate() {
    const custDate = new Date(this.birthdayDate);
    const custYear = custDate.getFullYear();
    const custMonth = custDate.getMonth() + 1;
    const custDay = custDate.getDate();
    const numberOfMonths =  this.isMonthVisibile;
    const custAddMonth = numberOfMonths + 1;
    const custAdjustMonths =  numberOfMonths - 1;   
    this.selectDOB = this.birthdayDate;
    this.selectDOB = this.birthdayDate;
    this.isVisibile = true;
    this.textHeight = numberOfMonths;

    if (numberOfMonths <= 3) {
        this.threeMonthsBeforeDate = custDate.setFullYear(custYear + 65);

        if (custDay === 1) {
          this.threeMonthsBeforeDate = custDate.setMonth(custDate.getMonth() - custAddMonth);
          this.dateOfBirth = custDate.setMonth(custDate.getMonth() + custAddMonth);
          this.threeMonthsAfterDate = custDate.setMonth(custDate.getMonth() + custAdjustMonths);
        }
        else{
          this.threeMonthsBeforeDate = custDate.setMonth(custDate.getMonth() - numberOfMonths);
          this.dateOfBirth = custDate.setMonth(custDate.getMonth() + numberOfMonths);
          this.threeMonthsAfterDate = custDate.setMonth(custDate.getMonth() + numberOfMonths);
          }
    }
    else {
    this.threeMonthsBeforeDate = custDate.setMonth(custDate.getMonth() - numberOfMonths);
    this.dateOfBirth = custDate.setMonth(custDate.getMonth() + numberOfMonths);
    this.threeMonthsAfterDate = custDate.setMonth(custDate.getMonth() + numberOfMonths);
    }

  }

  getDate(event) {
    this.birthdayDate = event.value;
    this.isDateInvalid=!moment(event.value,"MM/dd/yyyy",true).isValid();
  }

}